module.exports = __webpack_public_path__ + "premium_purchase_icon_2.png?1f7c1c87dd64071c27e17a25c15798ad";


//////////////////
// WEBPACK FOOTER
// ./static/img/premium_purchase_icon_2.png
// module id = 337
// module chunks = 0